<ng-component *transloco="let t">
    <div class="mt-1">
        <label class="col-form-label pt-0" for="name">{{t("Field settings Field Conditional (Template/Document - section) - Conditional")}}</label>
        <ng-select [compareWith]="selectedFeildFn" [closeOnSelect]="false" [multiple]="true" #roleSelecter [items]="conditional_fields" bindLabel="name" bindValue="uuid" [(ngModel)]="selectedConditioanl" [searchable]="true" [placeholder]="t('Field settings Select field (Template/Document - section) - Select field')" [clearable]="false"
            (change)="onSelectRelations($event)">
            <ng-template ng-option-tmp ng-label-tmp let-item="item" let-index="index" let-search="searchTerm" let-clear="clear">
                <div>
                    <div class="d-flex justify-content-between align-items-start">
                        <div class="d-flex flex-column align-items-start justify-content-center">
                            <span class="ng-value-label">{{ item.name }}</span>
                            <span *ngIf="item.selected_field === SelectedFieldEnum.DroplistField || item.selected_field === SelectedFieldEnum.ListField" class="text-muted">({{item.field_name}})</span>
                        </div>
                        <span class="field-type-label">{{ item.role_name }}</span>
                        <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                    </div>
                </div>
            </ng-template>
        </ng-select>
    </div>
</ng-component>